/**
 * Collapsible red-accented danger zone for the Agent Overview tab (§4.4.1).
 *
 * Houses Delete Agent and any future destructive actions. Collapsed
 * by default so people don't accidentally click "Delete".
 */
import { useState, type ReactNode } from 'react';
import { ChevronRight, AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DangerZoneProps {
  children: ReactNode;
}

export function DangerZone({ children }: DangerZoneProps) {
  const [open, setOpen] = useState(false);
  return (
    <section
      className={cn(
        'mt-12 border border-destructive/50 rounded-md bg-destructive/5',
        'focus-within:ring-2 focus-within:ring-destructive/30'
      )}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-2 p-4 text-left"
      >
        <span className="flex items-center gap-2 font-semibold text-destructive">
          <AlertTriangle className="h-5 w-5" />
          Danger zone
        </span>
        <ChevronRight
          className={cn(
            'h-4 w-4 text-destructive transition-transform',
            open && 'rotate-90'
          )}
        />
      </button>
      {open && (
        <div className="border-t border-destructive/30 p-4 space-y-4">
          {children}
        </div>
      )}
    </section>
  );
}
